import AOS from "aos/dist/aos";
import Header from "./modules/navigation/Header";
import Menu from "./modules/navigation/Menu";
import ScrollTo from "./modules/components/ScrollTo";
import Slider from "./modules/components/Slider";
import ProductCard from "./modules/cards/ProductCard";
import BlogPage from "./pages/BlogPage";
import SinglePost from "./pages/SinglePost";
import Search from "./pages/Search";
import CopyToClipboard from "./modules/components/CopyToClipboard";
import Tabs from "./modules/components/Tabs";
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
// Init AOS
AOS.init({
    offset: 150,
    duration: 500,
    easing: 'ease',
    delay: 100,
    once: true,
});
// Init navigation
new Header();
new Menu();
// Init slider components
const sliderComponents = document.querySelectorAll('.slider-default');
sliderComponents.forEach((component) => {
    new Slider(component);
});
// Init Card components
const cardComponents = document.querySelectorAll('.card-product');
cardComponents.forEach((component) => {
    new ProductCard(component);
});
// Scroll To
new ScrollTo();
// Copy to Clipboard
new CopyToClipboard();
// Init Tabs
document.querySelectorAll('[data-tabs]').forEach(container => {
    new Tabs(container);
});
// Pages
new BlogPage();
new SinglePost();
new Search();
